module.exports = __webpack_public_path__ + "img/join2-2.13d0691d.jpg";